import React, { useEffect, useState } from 'react'
import { Story } from '../types'
import Comments from './Comments'
import { timeToTimeAgo } from '../HelperFunctions'
import Loader from './Loader'

interface Props {
	id: number
}

const StoryItem: React.FC<Props> = ({ id }) => {
	const [story, setStory] = useState<Story>()
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		fetch(
			`https://hacker-news.firebaseio.com/v0/item/${id}.json?print=pretty`
		)
			.then((res) => res.json())
			.then((res) => {
				setStory(res)
				setIsLoading(false)
			})
			.catch((error) => console.log(error))
	}, [])

	return (
		<div className="story-item">
			{isLoading ? (
				<Loader />
			) : (
				<div>
					<h2>
						<a
							href={story?.url}
							rel="noreferrer"
							target="_blank"
							className="remove-decoration">
							{story?.title}
						</a>
					</h2>
					<span className="text-muted">
						<i className="text-blue">{story?.score}</i> points by{' '}
						<i className="text-blue">{story?.by}</i>{' '}
						{timeToTimeAgo(story?.time)}
					</span>
					<Comments commentsArr={story?.kids} />
				</div>
			)}
		</div>
	)
}

export default StoryItem
